import * as React from "react";
import { createRoot } from "react-dom/client";
import { GlobalState } from "./globalState";
import { WorkbenchEditor } from "./workbenchEditor";
import { CreatePopup } from "shared-ui-components/popupHelper";
/**
 * Class used to create a gui editor
 */
export class GUIEditor {
    /**
     * Show the gui editor
     * @param options defines the options to use to configure the gui editor
     * @param embed defines whether editor is being opened from the Playground
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static async Show(options, embed) {
        let hostElement = options.hostElement;
        // if we are in a standalone window and we have some current state, just load the GUI from the snippet server, don't do anything else
        if (this._CurrentState && hostElement) {
            if (options.currentSnippetToken) {
                try {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this._CurrentState.workbench.loadFromSnippet(options.currentSnippetToken);
                }
                catch (error) {
                    //swallow and continue
                }
            }
            return;
        }
        if (!hostElement) {
            if (this._PopupWindow) {
                this._PopupWindow.close();
            }
            hostElement = CreatePopup("BABYLON.JS GUI EDITOR", { onWindowCreateCallback: (w) => (this._PopupWindow = w), width: 1200, height: 800 });
        }
        const globalState = new GlobalState();
        if (options.liveGuiTexture) {
            globalState.liveGuiTexture = options.liveGuiTexture;
        }
        globalState.hostElement = hostElement;
        globalState.hostDocument = hostElement.ownerDocument;
        globalState.customSave = options.customSave;
        globalState.customLoad = options.customLoad;
        globalState.hostWindow = hostElement.ownerDocument.defaultView;
        globalState.registerEventListeners();
        const onReadyAsync = async () => {
            // create the middle workbench canvas
            if (!globalState.guiTexture) {
                globalState.workbench.createGUICanvas(embed);
                if (options.currentSnippetToken) {
                    try {
                        await globalState.workbench.loadFromSnippet(options.currentSnippetToken);
                    }
                    catch (error) {
                        //swallow and continue
                    }
                }
            }
        };
        const graphEditor = React.createElement(WorkbenchEditor, {
            globalState,
            onReady: onReadyAsync,
        });
        const root = createRoot(hostElement);
        root.render(graphEditor);
        if (options.customLoadObservable) {
            options.customLoadObservable.add(() => {
                globalState.onResetRequiredObservable.notifyObservers();
                globalState.onBuiltObservable.notifyObservers();
            });
        }
        this._CurrentState = globalState;
        // Close the popup window when the page is refreshed or scene is disposed
        if (this._PopupWindow) {
            window.onbeforeunload = () => {
                if (this._PopupWindow) {
                    this._PopupWindow.close();
                }
            };
        }
        globalState.hostWindow.addEventListener("beforeunload", () => {
            globalState.onPopupClosedObservable.notifyObservers();
            globalState.dispose();
        });
    }
}
/** @internal */
GUIEditor._PopupWindow = null;
//# sourceMappingURL=guiEditor.js.map